import Model, { attr, belongsTo } from '@ember-data/model';
import { cached } from '@glimmer/tracking';
import { differenceInDays } from 'date-fns/differenceInDays';
import type {
  IUnavailabilitySchema,
  UnavailabilitySource,
} from 'uplisting-frontend/models/schemas';
import BookingModel from 'uplisting-frontend/models/booking';
import CalendarModel from 'uplisting-frontend/models/calendar';
import PropertyModel from 'uplisting-frontend/models/property';
import MultiUnitModel from 'uplisting-frontend/models/multi-unit';

export default class UnavailabilityModel
  extends Model
  implements IUnavailabilitySchema
{
  @attr('string') source!: UnavailabilitySource;
  @attr('string') description!: string;
  @attr('date') from!: Date;
  @attr('date') to!: Date;

  @cached
  get duration(): number {
    return differenceInDays(this.to, this.from);
  }

  @cached
  get startDate(): Date {
    return this.from;
  }

  @cached
  get endDate(): Date {
    return this.to;
  }

  @belongsTo('booking', {
    inverse: null,
    async: false,
  })
  booking!: BookingModel;

  @belongsTo('calendar', {
    inverse: 'unavailabilities',
    async: false,
  })
  calendar!: CalendarModel;

  @belongsTo('property', {
    inverse: 'unavailabilities',
    async: false,
  })
  property!: PropertyModel;

  @belongsTo('multi-unit', {
    inverse: 'unavailabilities',
    async: false,
  })
  multiUnit!: MultiUnitModel;
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    unavailability: UnavailabilityModel;
  }
}
